import { ReservationButton } from "src/components/reservation-button";
import { TopSection } from "src/components/_pages/home/top-section";
import { ConceptSection } from "src/components/_pages/home/concept-section";
import { ExperienceSection } from "src/components/_pages/home/experience-section";
import { FishingSection } from "src/components/_pages/home/fishing-section";
import { DivingSection } from "src/components/_pages/home/diving-section";
import { LivingSection } from "src/components/_pages/home/living-section";
import { KitchenSection } from "src/components/_pages/home/kitchen-section";
import { FlexibleSection } from "src/components/_pages/home/flexible-section";
import { PriceSection } from "src/components/_pages/home/price-section";
import { ExperienceFeeSection } from "src/components/_pages/home/experience-fee-section";
import { FacilitySection } from "src/components/_pages/home/facility-section";
import { PhotoSection } from "src/components/_pages/home/photo-section";
import { AccessSection } from "src/components/_pages/home/access-section";
import { Footer } from "src/components/footer";

const Home = () => {
  return (
    <>
      <title>石巻マリンヴィレッジ | 海のある暮らしを体験できる一棟貸し宿泊施設</title>
      <article>
        <ReservationButton />
        <TopSection />
        <ConceptSection />
        <ExperienceSection />
        <FishingSection />
        <DivingSection />
        <LivingSection />
        <KitchenSection />
        <FlexibleSection />
        <PriceSection />
        <ExperienceFeeSection />
        <FacilitySection />
        <PhotoSection />
        <AccessSection />
        <Footer />
      </article>
    </>
  );
};

export default Home;
